import React from "react";

export default function CloseIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <mask id="mask0_2685_1603" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <rect width="16" height="16" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_2685_1603)">
            <path d="M4.26671 12.4358L3.56421 11.7333L7.29754 8.00001L3.56421 4.26668L4.26671 3.56418L8.00004 7.29751L11.7334 3.56418L12.4359 4.26668L8.70254 8.00001L12.4359 11.7333L11.7334 12.4358L8.00004 8.70251L4.26671 12.4358Z" fill="#1C1B1F"/>
        </g>
    </svg>
  );
}
